<!--Buttons-->

<div [ngClass]="{'col-2': showProcessingDetailBtn, 'col-3 centered': !showProcessingDetailBtn}">
  <button pButton type="button" [label]="'FOLD.ACTION_COMPONENT.DEPOSIT_BUTTON' | translate"
          (click)="loadDeposit()"></button>
</div>
<div *ngIf="showProcessingDetailBtn" class="col-2">
  <button *ngIf="currentUser.admin" pButton type="button" [label]="'FOLD.ACTION_COMPONENT.TREATMENT_BUTTON' | translate"
          (click)="loadTreatment()" [disabled]="!hasTreatement()"></button>
</div>
<div class="visuButton" [ngClass]="{'col-2': showProcessingDetailBtn, 'col-3': !showProcessingDetailBtn}">
  <!-- <button pButton type="button" [label]="'FOLD.ACTION_COMPONENT."Reason:' | translate"
           (click)="loadVisualization()" [disabled]="!isViewable()" class="p-button-info"></button>-->
  <p-splitButton [disabled]="fold.serialSent <1" [label]="'FOLD.ACTION_COMPONENT.VISU_DOCUMENT_BUTTON' | translate"
                 icon="fa fa-eye" (onClick)="loadVisu()" [model]="items"></p-splitButton>
</div>
<div class="col-2">
  <button pButton type="button" [label]="'FOLD.ACTION_COMPONENT.ADD_BUTTON' | translate"
          [disabled]="!addressable()"
          (click)="loadAdress()" class="p-button-success"></button>
</div>
<div class="col-2">
  <button *ngIf="!isFoldStatusDiscard()" pButton type="button" [label]="'FOLD.ACTION_COMPONENT.EXCLUDE_BUTTON' | translate"
          [disabled]="!isFoldExcludable()"
          (click)="loadExclude()" class="p-button-warning"></button>
</div>

<div class="col-2" *ngIf="isFoldPlannable()">

  <button pButton type="button" [label]="'FOLD.ACTION_COMPONENT.PLAN_FOR_BUTTON' | translate"
          [disabled]="!isFoldPlannable()"
          (click)="loadPlanFor()" class="p-button-warning"></button>

</div>
<div class="col-2" *ngIf="isFoldPlanned()">
  <button pButton type="button" [label]="'FOLD.ACTION_COMPONENT.PLAN_CANCEL_BUTTON' | translate"
          [disabled]="!isFoldPlanned()"
          (click)="loadCancelPlan()" class="p-button-warning"></button>
</div>
<!--Dirty legacy behavior handling-->
<div class="col-2">
  <button *ngIf="isFoldStatusFail() " pButton type="button"
          [label]="'FOLD.ACTION_COMPONENT.RESTORE_BUTTON' | translate"
          [disabled]="!restoreEnabled()"
          (click)="loadNewRun()" class="p-button-warning"></button>
</div>
<div class="col-2">
  <button *ngIf="isFoldStatusDiscard()" pButton type="button"
          [label]="'FOLD.ACTION_COMPONENT.RESTORE_BUTTON' | translate"
          [disabled]="!restoreEnabled()"
          (click)="loadRestore()" class="p-button-warning"></button>
</div>
<!--Deposit modal-->
<p-dialog *ngIf="openDeposit" [(visible)]="openDeposit" [styleClass]="'dataTablesModal'" [appendTo]="'body'"
          [header]="'FOLD.ACTION_COMPONENT.DEPOSIT_MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true"
          [closeOnEscape]="false">
  <app-custom-list [columns]="depositColumns" [datas]="datas" [consultable]="true"
                   [downloadable]="true"></app-custom-list>
</p-dialog>
<!--End of Deposit-->

<!--Treatment modal-->
<p-dialog *ngIf="openTreatment" [(visible)]="openTreatment" [styleClass]="'dataTablesModal'" [appendTo]="'body'"
          [draggable]="false"
          [closable]="false"
          [resizable]="false"
          [modal]="true"

          [closeOnEscape]="false">
  <ng-template pTemplate="header">
    <div class="p-dialog-header-content">
      <div class="col-4">
        {{('FOLD.ACTION_COMPONENT.TREATMENT_MODAL_TITLE' | translate) + ' : ' + fold.serialSent}}
      </div>
      <div class="col-8 p-dialog-header-buttons">
        <button pButton type="button"
                [label]=""
                style="float:right;margin-left: 2px;"
                (click)="close()" icon="fa fa-close"></button>
        <button pButton type="button"
                [label]=""
                style="float:right;"
                (click)="update()" icon="fa fa-refresh"></button>
      </div>
    </div>
  </ng-template>
  <!--<p-header>
    <button pButton type="button"
            [label]=""
            style="float:right;margin-left: 2px;"
            (click)="close()" icon="fa fa-close"></button>
    <button pButton type="button"
            [label]=""
            style="float:right;"
            (click)="update()" icon="fa fa-refresh"></button>

  </p-header>-->
  <app-custom-list *ngIf="!fold.erlId" [columns]="treatmentColumns" [datas]="datas" [consultable]="true"
                   [downloadable]="true"
                   [convertibleAsText]="true"></app-custom-list>
  <app-custom-list *ngIf="fold.erlId" [columns]="erlTreatmentColumns" [datas]="datas" [consultable]="false"
                   [downloadable]="false"
                   [convertibleAsText]="false"></app-custom-list>
</p-dialog>
<!--End of Treatment-->

<!--Visualization modal-->
<p-dialog [styleClass]="'file-display-dialog'" [appendTo]="'body'" [(visible)]="openVisualization"
          [header]="this.fold.serialSent" (onHide)="freeDocMemory(pdfToDisplay)"
          [draggable]="true"
          [closable]="true"
          [maximizable]="true"
          [modal]="true" [closeOnEscape]="true">
  <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay| safeObjUrl" type="application/pdf" width="100%"
          height="100%"></object>
  <!-- <a href="pdfToDisplay">Download PDF</a>-->
</p-dialog>
<!--End of visualization modal-->

<!--Adress modal-->

<p-dialog *ngIf="openAdress" [(visible)]="openAdress" [styleClass]="'adressModal'" [appendTo]="'body'"
          [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true" [closeOnEscape]="false">
  <app-address [fold]="fold" (visible)="handleAddressClose($event)"></app-address>
</p-dialog>
<!--End of Adress modal-->

<!--Confirm or exclude modal-->
<app-action-confirm *ngIf="openConfirmOrExclude" [fold]="fold" (visible)="handleConfirmOrExcludeModalClose($event)"
                    [kindOfActionConfirm]="userChoiceOfAction"></app-action-confirm>
<!--EConfirm or exclude modal-->

